import { requestGet } from '../utils/requestApi'

export async function getCateList(payload){
  return requestGet('index', payload)
}